import GameKit from './GameKit';
import { PrefabLibraryEntry } from './Game/Base/Library';
import LibraryManager from './Game/Base/Library/LibraryManager';

const CheatFlags = {
    Alpha: 1,
    Beta: 2,
    Charlie: 4,
    Delta: 8,
    Echo: 16,
    Foxtrot: 32,
    Golf: 64
};

class Cheats {
    constructor() {
        window.Cheats = this;

        this.enabled = 0;

        this.customPrefabs = [];
    }

    start() {}

    credits() {
        console.log('The GameKit and GamePlayer are programmed by Olivier Wervers, Meine Zeinstra and Stefan de Raadt.');
    }

    createPrefab(name = 'Unknown', id = 'unknown') {
        const blok = GameKit.levelEditor.blokEditor.getSelectedBlok();
        if (!blok) {
            console.log('Please select a block first.');
            return;
        }
        const serialized = blok.serialize();
        delete serialized.uuid;
        delete serialized.position;
        delete serialized.name;

        const prefabObj = {
            name,
            id,
            preview: `textures.${serialized.states[0].appearance.texture}`
        };

        if (blok.states[0].appearance.hue !== 0) {
            prefabObj.previewHue = blok.states[0].appearance.hue;
        }
        prefabObj.data = serialized;

        console.log(JSON.stringify(prefabObj));
        this.customPrefabs.push(prefabObj);

        const entry = new PrefabLibraryEntry(id);
        entry.deserialize(prefabObj);
        LibraryManager.prefabs.getCategory(4).addItem(entry);
    }
}

export default new Cheats();
